module.exports = __webpack_public_path__ + "static/media/Logo-Login@2x.24be8f7c.png";